
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import DashboardSidebar from "@/components/DashboardSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Card } from "@/components/ui/card";
import LicensePlateInput from "@/components/vehicle/LicensePlateInput";
import VehicleDetails from "@/components/vehicle/VehicleDetails";
import { LayoutGrid } from "lucide-react";

const AddVehicle = () => {
  const [vehicleData, setVehicleData] = useState<any>(null);

  const handleVehicleDataFetched = (data: any) => {
    setVehicleData(data);
  };

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <DashboardSidebar />
        <main className="flex-1 overflow-auto bg-white">
          <div className="flex flex-col min-h-screen">
            <div className="flex-grow px-4 py-6 md:p-8">
              <div className="max-w-6xl mx-auto space-y-6">
                <div className="text-left mb-8">
                  <h1 className="text-2xl md:text-3xl font-bold text-[#B1A06D]">
                    Voertuig Toevoegen
                  </h1>
                  <p className="text-gray-600 mt-2 text-sm md:text-base">
                    Voer een kenteken in om automatisch de voertuiggegevens op te halen
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Card className="overflow-hidden bg-gray-100 min-h-[400px]">
                    <div className="p-6 h-full flex items-center justify-center">
                      <LicensePlateInput onVehicleDataFetched={handleVehicleDataFetched} />
                    </div>
                  </Card>

                  <AnimatePresence mode="wait">
                    {vehicleData ? (
                      <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -20 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="h-full"
                      >
                        <Card className="overflow-hidden bg-gray-100 min-h-[400px]">
                          <div className="p-6 h-full flex flex-col justify-center">
                            <h2 className="text-lg font-semibold mb-4 text-[#B1A06D]">
                              Voertuig Gegevens
                            </h2>
                            <VehicleDetails vehicleData={vehicleData} />
                          </div>
                        </Card>
                      </motion.div>
                    ) : (
                      <Card className="overflow-hidden bg-gray-100 min-h-[400px] flex items-center justify-center">
                        <div className="flex flex-col items-center justify-center text-gray-400">
                          <LayoutGrid className="w-12 h-12 mb-4" />
                          <p>Voer een kenteken in om de voertuiggegevens te zien</p>
                        </div>
                      </Card>
                    )}
                  </AnimatePresence>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default AddVehicle;
